module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAABO0lEQVQ4jaWTvytFYRjHP67cRbgSZTNQymL2o0wmi7IqFpOiDFL+hFuyKJPFH+DHYLGTUigZlJ3h4paB6KOX99RxnNzb9a2nzvd5v+/nnPec86DWqn51Xu3Nye2qZbUl6f0F61G31He/dZaTWYtre2ohAbaqY+pEqtbVqj/1lAMMtRxTqwnw2vqUBp6oGym/r76o3dQJMwMsx95k9EPRrzT59Zx16RkoxWARuAMugKnYuwQeCnXCsnoDDoDxVP8cGGwUGHQPtKd8FWj7D7AvHDHlu4DHRoHhXU4Dx6neCHDV6FcOE/KhDkc/GjMLwRz92pqvNHBHXYzXzeqp+hCGJAl0qKVYneqMepvBPuZMSfjtwngGzdaa5aK6pFbihnCSbGY7rm0mvXCHWh+gFRgAboDXzNocUAEOAQE+AZKLh/KFZwbTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/build901/components/common/marquee/img/_white.png
// module id = r/Cn
// module chunks = 47